import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconArrowBackUp } from '@tabler/icons-react';
import React from 'react';
import { HiOutlinePlus } from 'react-icons/hi';
import MaterialInputDataForm from './MaterialInputDataForm';

interface FormMaterialInputProps {
  role: 'admin' | 'sme';
  hashKey: string;
  courseId?: string;
  onSubmit: (_data: {
    hash?: string;
    materials: {
      title: string;
      url: string;
      type: string;
      description?: string;
    }[];
  }) => void;
}

const FormMaterialInput: React.FC<FormMaterialInputProps> = ({ hashKey, onSubmit, courseId }) => {
  const [openedAddSection, { open: openAddSection, close: closeAddSection }] = useDisclosure(false);

  return (
    <>
      {/* {role === 'sme' && ( */}
      <Button
        fullWidth
        variant={openedAddSection ? 'default' : 'outline'}
        leftSection={openedAddSection ? <IconArrowBackUp /> : <HiOutlinePlus />}
        onClick={() => (openedAddSection ? closeAddSection() : openAddSection())}
      >
        {openedAddSection ? 'Cancel' : 'Add Material'}
      </Button>
      {/* )} */}
      {openedAddSection && (
        <MaterialInputDataForm
          hashKey={hashKey}
          courseId={courseId}
          onSubmit={onSubmit}
          onCancel={closeAddSection}
        />
      )}
    </>
  );
};

export default FormMaterialInput;
